import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../../../core/reducers';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { Category } from '../models';
import {
  selectCategoryPage,
  selectCategoryPageLoading,
  selectCategoryShowInitWaitingMessage,
} from '../selectors';

export class CategoryDataSource extends BaseDataSource {
  private _categories: Category[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectCategoryPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectCategoryShowInitWaitingMessage);

    this.store
      .pipe(select(selectCategoryPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._categories = res.items;

        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get categories() {
    return this._categories;
  }
}
